import { matchPath, Location } from "react-router-dom";
import { ArrayElement } from "@epcnetwork/core-ui-kit";

import { DEFAULT_PAGE } from "constants/routes.constants";
import { routes } from "config/routes.config";

export const isActiveRoute = (routePath: string, location: Location): boolean => {
  if (routePath === DEFAULT_PAGE.path && location.pathname === "/") {
    return true;
  }

  return Boolean(matchPath(routePath, location.pathname));
};

export const getActiveRoute = (location: Location): ArrayElement<typeof routes> => {
  const activeRoute = routes.find((route) => isActiveRoute(route.path, location));

  if (activeRoute) {
    return activeRoute;
  }
  return routes[routes.length - 1];
};
